const t = "atticus-prematter-id", T = "atticus-job-id", _ = "atticus-email", E = "prematter-id";
export {
  _ as ATTICUS_EMAIL_KEY,
  T as ATTICUS_JOB_ID_KEY,
  t as ATTICUS_PREMATTER_ID_KEY,
  E as PREMATTER_ID_COOKIE
};
